/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InformationGatheringDestination {
  RedRobin = 'red-robin',
  Messaging = 'messaging',
  CareNavigation = 'care-navigation'
}
